import {
  createApiFactory,
  createPlugin,
  discoveryApiRef,
} from '@backstage/core-plugin-api';

import { jiraApptioApiRef, JiraApptioClient } from './api';

export const jiraPlugin = createPlugin({
  id: 'jira.apptio',
  apis: [
    createApiFactory({
      api: jiraApptioApiRef,
      deps: { discoveryApi: discoveryApiRef },
      factory: ({ discoveryApi }) => JiraApptioClient.fromConfig(discoveryApi),
    }),
  ],
});
